export enum ScopeType {
	Project = 'Project',
	Client = 'Client',
}
